import './radioButtonGroup.scss';
import type { RadioButtonGroupProps } from "./RadioButtonGroup.interface";

export function RadioButtonGroup(props: RadioButtonGroupProps) {
    return (
        <div className={["radiobutton-group", props.className].join(" ")}>
            {props.children}
        </div>
    );
};
